// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '../icons/Icon';
import AnchorButton from '../buttons/AnchorButton';

// Styles
import './PopupErrorMessage.scss';

const PopupErrorMessage = ({ description, onCtaClick }) => (
    <div className="PopupErrorMessage">
        <Icon name="error-alert" />
        <div className="description">{description}</div>
        <AnchorButton onClickFn={onCtaClick}>Try again</AnchorButton>
    </div>
);

PopupErrorMessage.propTypes = {
    description: PropTypes.string,
    onCtaClick: PropTypes.func,
};

export default PopupErrorMessage;
